import { Box, Stack } from '@atgfr8/atg-ui-tailwind';
import { InformationIcon } from '@atgfr8/icons';

type PropsT = {
  message: string;
  title?: string;
  onView?: () => void;
  showIcon?: boolean;
};

export const ErrorRow = (props: PropsT) => {
  return (
    <Box
      backgroundColor="#b00020"
      borderRadius="4px"
      color="#fff"
      padding="4px 8px 4px 8px"
      minHeight="44px"
    >
      <Stack direction="row" gap="6px" minHeight="44px">
        <Box
          style={{ display: 'flex' }}
          alignItems="center"
          justifyContent="center"
        >
          <InformationIcon />
        </Box>
        <Box flex={1} style={{ display: 'flex' }} alignItems="center">
          <Box>
            {props.title !== undefined ? (
              <Box fontSize="16px">{props.title}</Box>
            ) : undefined}
            <Box fontSize="14px">{props.message}</Box>
          </Box>
        </Box>
        {props.onView !== undefined ? (
          <Box
            style={{ cursor: 'pointer', display: 'flex' }}
            justifyContent="center"
            alignItems="center"
            onClick={props.onView}
          >
            <Box>VIEW ERROR</Box>
          </Box>
        ) : undefined}
      </Stack>
    </Box>
  );
};
